// extracted by mini-css-extract-plugin
module.exports = {"total":"styles_total__AyuZb","totalGlow":"styles_totalGlow__RJ6C_","caraPulse":"styles_caraPulse__iwMHM"};